import {
  ROLES,
  ORGANIZATION_HIERARCHY,
  TASKS_OVERVIEW,
  CONFIGURATION_KEYS
} from 'constants/enums'

// { organizationHierarchyId = ORGANIZATION_HIERARCHY.AU.id } = {}
export const tabs = ({ isIac } = {}) => {
  return [
    {
      id: 1,
      label: 'Detail',
      path: '/detail',
      intlKey: 'tabs.detail',
      roles: [ROLES.ALL.u]
    },
    {
      id: 2,
      label: 'Participants',
      path: '/participants',
      intlKey: 'tabs.participants',
      roles: [ROLES.ALL.u]
    },
    {
      id: 3,
      label: 'Leaders',
      path: '/leaders',
      intlKey: 'tabs.leaders',
      roles: [ROLES.ALL.u]
    },
    {
      id: 4,
      label: 'Registrations',
      path: '/registrations',
      intlKey: 'tabs.registrations',
      roles: [ROLES.ALL.u],
      counters: [
        TASKS_OVERVIEW.AWARD_REGISTRATION.id,
        TASKS_OVERVIEW.AL_REGISTRATION.id,
        TASKS_OVERVIEW.ASSESSOR_REGISTRATION.id,
        TASKS_OVERVIEW.ASSESSOR_ACTIVITY_REGISTRATION.id
      ]
    },
    {
      id: 5,
      label: 'Payments',
      path: '/payments',
      intlKey: 'tabs.payments',
      roles: [ROLES.ALL.u],
      visibility: isIac ? 'hidden' : 'visible'
      // configs: [CONFIGURATION_KEYS.onlineMasterCardPayment.id]
    },
    {
      id: 6,
      label: 'Adventurous Journey',
      path: '/adventurous-journeys',
      intlKey: 'tabs.adventurous_journeys',
      roles: [ROLES.ALL.u]
    },
    {
      id: 7,
      label: 'Assessors',
      path: '/assessors',
      intlKey: 'tabs.assessors',
      roles: [ROLES.ALL.u],
      configs: [CONFIGURATION_KEYS.manageAssessors.id]
    },
    {
      id: 8,
      label: 'Logs',
      path: '/logs',
      intlKey: 'tabs.logs',
      roles: [ROLES.ALL.u]
    },
    {
      id: 9,
      label: 'Customizations',
      path: '/customizations',
      intlKey: 'tabs.customizations',
      roles: [ROLES.ALL.u],
      tabClassName: 'aside'
      // visibility: isIac ? 'visible' : 'hidden'
    }
  ]
}

export const tableHeaders = (
  {
    organizationHierarchyId = ORGANIZATION_HIERARCHY.NAO.id,
    isIac = false,
    isDetail = false,
    isOrganizationLabelsEnabled = false,
    isGOP = false
  } = {}
) => {
  let parentOrganizationIntlKey = 'table.nao'

  switch (organizationHierarchyId) {
    case ORGANIZATION_HIERARCHY.OA.id:
      parentOrganizationIntlKey = 'table.operating_authorities'
      break
    case ORGANIZATION_HIERARCHY.SOA.id:
      parentOrganizationIntlKey = 'table.suboperating_authorities'
      break
    case ORGANIZATION_HIERARCHY.IC.id:
      parentOrganizationIntlKey = 'table.ic'
      break
    default:
      parentOrganizationIntlKey = 'table.nao'
  }

  if (isIac) {
    parentOrganizationIntlKey = 'table.country'
  }

  return [
    {
      id: 0,
      label: '',
      intlKey: '',
      sortableId: '',
      selector: true
    },
    {
      id: 1,
      label: 'ID',
      intlKey: 'table.id',
      sortableId: 'id'
    },
    {
      id: 2,
      label: 'Name',
      intlKey: 'table.name',
      sortableId: 'name'
    },
    {
      id: 3,
      label: 'Lead Coordinator',
      intlKey: 'table.lead_coordinator',
      sortable: false
    },
    {
      id: 4,
      label: 'Type',
      intlKey: 'table.type',
      sortableId: 'organizationType.value'
    },
    {
      id: 5,
      label: 'Operating Authority',
      intlKey: 'table.operating_authority',
      sortableId: 'parentOA',
      displayForRoles: [ROLES.GOP_STAFF.u, ROLES.NAO_STAFF.u, ROLES.IF_STAFF_SUPER.u],
      hide: isIac || isGOP
    },
    {
      id: 6,
      label: 'Sub-Operating Authority',
      intlKey: 'table.suboperating_authority',
      sortableId: 'parentOA',
      displayForRoles: [ROLES.OA.u],
      hide: isDetail
    },
    {
      id: 7,
      label: 'Parent',
      intlKey: parentOrganizationIntlKey,
      sortableId: 'parent.name',
      displayForRoles: [
        ROLES.GOP_STAFF.u,
        ROLES.IF_STAFF_SUPER.u,
        ROLES.IF_REGION.u,
        ROLES.IF_STAFF_USER.u,
        ROLES.IF_STAFF_VIEWER.u,
        ROLES.GBT.u
      ],
      hide: isDetail
    },
    {
      id: 8,
      label: 'Region',
      intlKey: 'table.region',
      sortableId: 'region.name',
      displayForRoles: [ROLES.IF_STAFF_SUPER.u],
      hide: isDetail
    },
    {
      id: 9,
      label: 'Organization Labels',
      intlKey: 'table.organization_labels',
      sortableId: 'labels.label.name',
      hide: !isOrganizationLabelsEnabled
    },
    {
      id: 10,
      label: 'State',
      intlKey: 'table.state',
      sortable: false
    }
  ]
}

export const tableHeadersSimple = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'Name',
    intlKey: 'table.name',
    sortable: false
  },
  {
    id: 3,
    label: 'Type',
    intlKey: 'table.type',
    sortable: false
  },
  {
    id: 4,
    label: 'Region',
    intlKey: 'table.region',
    sortable: false
  }
]
